import { spaceClient } from './client';

// ── Packages ─────────────────────────────────────────────────────────────
// CMS reads go through /cms/... (draft+pending+approved); writes go through
// the plain /packages path, which routes through content-approval — same
// convention itemApi.js/Free Trial already use.

export const getPackages = () =>
  spaceClient.get('/cms/packages', { withCredentials: true }).then((r) => r.data);

export const getPackageById = (id) =>
  spaceClient.get(`/cms/packages/${id}`, { withCredentials: true }).then((r) => r.data);

export const getPackageItems = (id) =>
  spaceClient.get(`/cms/packages/${id}/items`, { withCredentials: true }).then((r) => r.data);

export const createPackage = (data) =>
  spaceClient.post('/packages', data, { withCredentials: true }).then((r) => r.data);

export const updatePackage = (id, data) =>
  spaceClient.put(`/packages/${id}`, data, { withCredentials: true }).then((r) => r.data);

export const deletePackage = (id) =>
  spaceClient.delete(`/packages/${id}`, { withCredentials: true }).then((r) => r.data);

export const addPackageItem = (id, itemId, quantity = 1) =>
  spaceClient.post(`/packages/${id}/items`, { itemId, quantity }, { withCredentials: true }).then((r) => r.data);

export const removePackageItem = (id, itemId) =>
  spaceClient.delete(`/packages/${id}/items/${itemId}`, { withCredentials: true }).then((r) => r.data);
